///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { GtthHomeModule } from './home/home.module';
import { GtthAccountModule } from './account/account.module';
import { GtthCustomersModule } from './customers-config/customers.module';
import { GtthProjectViewModule } from './project-view-panel/project-view.module';
import { GtthServicesModule } from './services/services.module';
import { GtthAppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandlerInterceptor } from './blocks/interceptor/errorhandler.interceptor';
import { GtthProjectsListModule } from './projects/projects.module';
import { GtthSharedModule } from './shared/shared.module';
import { WindeMainComponent } from './layouts/main/main.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { ErrorComponent } from './layouts/error/error.component';
import { GtthFeedbackModule } from './shared/feedback/feedback.module';
import { GtthPreferencesModule } from './preferences/preferences.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { ENABLE_PROD_MODE } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatDialogClose } from '@angular/material/dialog';
import { UserSessionRestoringContentComponent } from './shared/auth/user-session-restoring/notification-content/user-session-restoring-content.component';
import { NOTIFICATION_SERVICE_CONFIG_TOKEN, SuiNotificationServiceConfig, SuiTooltipDirective } from '@siklu/sui-lib/infrastructure';
import { metaReducers } from './shared/store/meta-reducers';
import { SuiLoadingDirective, SuiSvgIconComponent, SuiTranslatePipe } from '@siklu/sui-lib';

@NgModule({
    imports: [
        BrowserModule,
        GtthSharedModule,
        GtthHomeModule,
        GtthAccountModule,
        GtthCustomersModule,
        GtthProjectViewModule,
        GtthServicesModule,
        GtthAppRoutingModule,
        GtthFeedbackModule,
        GtthProjectsListModule,
        GtthPreferencesModule,
        BrowserAnimationsModule,
        StoreModule.forRoot({ router: routerReducer }, { metaReducers }),
        StoreRouterConnectingModule.forRoot(),
        EffectsModule.forRoot([]),
        ENABLE_PROD_MODE ? [] : [StoreDevtoolsModule.instrument({ maxAge: 25, connectInZone: true })],
        ServiceWorkerModule.register('auto-logout-worker.js', { enabled: true }),
        MatDialogClose,
        SuiLoadingDirective,
        SuiTooltipDirective,
        SuiTranslatePipe,
        SuiSvgIconComponent,
        NavbarComponent
    ],
    declarations: [WindeMainComponent, ErrorComponent, UserSessionRestoringContentComponent],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true
        },
        {
            provide: NOTIFICATION_SERVICE_CONFIG_TOKEN,
            useValue: {
                container: {
                    notificationsMaxCount: 5,
                    closeIcon: 'cross',
                    width: 400,
                    position: {
                        top: 50
                    }
                }
            } as SuiNotificationServiceConfig
        }
    ],
    bootstrap: [WindeMainComponent]
})
export class WindeAppModule {}
